const stub = { isEnabled: () => false, isHidden: true, name: 'stub' };
export default stub;
export const resetLimits = stub;
export const resetLimitsNonInteractive = stub;
